import { container } from "tsyringe";

import { ElementsIndex } from "./ElementsIndex";

export const registerElementInIndex = (
    node: HTMLElement,
    elementName: string
) => {
    const elementsIndex = container.resolve(ElementsIndex);

    elementsIndex.registerElement(elementName, node);
    return {
        destroy() {
            elementsIndex.unregisterElement(elementName);
        },
    };
};
